import { DESKTOP_RETURN_SCHEME } from '@featit/shared/desktop/return-link';
import { isDesktopRuntime } from './desktopDetection';

/**
 * The `featit-return` scheme this desktop build registered, when it is not the shipped one
 * (T-0561). The Rust side owns the answer (`desktop_return_scheme`), because the same constant
 * decides what the OS is told to hand back to this app; the web asks once and sends it with a
 * sign-in or billing start so the backend mints a link this build alone receives.
 *
 * `undefined` for a browser tab and for the shipped app, which send nothing and get the default.
 */
export async function desktopReturnSchemeOverride(): Promise<string | undefined> {
  if (!isDesktopRuntime()) return undefined;
  try {
    const { invoke } = await import('@tauri-apps/api/core');
    const scheme = await invoke<unknown>('desktop_return_scheme');
    return typeof scheme === 'string' && scheme !== DESKTOP_RETURN_SCHEME ? scheme : undefined;
  } catch {
    return undefined;
  }
}
